<ol class="list-unstyled">
    <li *ngFor="let proposta of filter()">
        <app-ficha-card [proposta]="proposta" [idFase]="1"></app-ficha-card>
    </li>
</ol>
<div *ngIf="propostas.length === 0">
    <h2>Não foram encontradas propostas para essa fase</h2>
</div>